import debugConfig from "../../../../../../../config/debug-config";
import _getRestApi from "src/js/shared/trello-client/_get-rest-api";
import { Trello } from "types/my-trello-types";

export class TrelloIframeMockFactory {
    static create(): Trello.PowerUp.IFrame {
        return {
            // @ts-ignore
            getContext: () => ({
                board: debugConfig.idBoard,
                card: "5fc00876a49c25382a80042c",
                // command: "callback",
                // el: "9QlDup0FQGxnNbtN",
                member: debugConfig.idMember,
                organization: "55634a7afc3918bfa6ca19e6",
                enterprise: "6298ce27a330b800e23d89e0",
                // permissions: {board: "write", organization: "write", card: "write"},
                // version: "build-6535",
            }),
            getRestApi: () => ({
                getToken: () =>
                    Promise.resolve(process.env.DEBUG_TOKEN ?? "DummyTOKENValue"),
                // Promise.resolve("DummyTOKENValue"),
                // Promise.resolve(undefined),
                isAuthorized: () => Promise.resolve(true),
                clearToken: () => Promise.resolve(),
                authorize: () => Promise.resolve(),
            }),
            // card: () => Promise.resolve({id: "5fc00876a49c25382a80042c", shortLink: "kncqBVt0", url: "https://trello.com/c/kncqBVt0/1162-testing-test1-card-name-xyz-ha"} as Trello.Card),
            render: () => { },
            sizeTo: () => Promise.resolve(),
            set: () => {
                console.warn(
                    "'t.set()' cant be used while on localhost. Use with PU embeded in Trello context"
                );
                return Promise.resolve();
            },
            get: () =>
                Promise.resolve([
                    {
                        board: "5e320adb81f55f6a2180cbb5",
                        done: ["5e97149b65fd666d64493d0a", "5e9b4c546bfde1241eae72b0"],
                        wip: [
                            "5fa2bf3a662e9313d59728a6",
                            "5e320adb81f55f6a2180cbbc",
                            "5e320adb81f55f6a2180cbb8",
                        ],
                    },
                    {
                        board: "5d5310e4dddec42b7fbd6116",
                        done: ["5d53114492de7730f72d22b6"],
                        wip: ["5d5311429c994e8904c38461"],
                    },
                ]),
            closeModal: () => new Promise(() => { }),
        };
    }
}